var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('CLoader',{ref:"loadingOverlay"}),_vm._v(" "),_c('CButton',{attrs:{"properties":_vm.buttonProperties},on:{"click":_vm.getCenterPoint}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }